import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6727bb34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary d-flex align-items-center",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " An example alert with an icon ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Rider Earning Report")
  ])
], -1))
const _hoisted_5 = { class: "col-12 bg-light p-3" }
const _hoisted_6 = { class: "row height d-flex justify-content-center align-items-center" }
const _hoisted_7 = { class: "col-md-3 text-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "From Date", -1))
const _hoisted_9 = { class: "col-md-3 text-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "To Date", -1))
const _hoisted_11 = { class: "col-md-3 text-start" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table table-striped table-sm" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Rider Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Phone"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total Order "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Rider Earning"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Cash Collected"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Net Total")
  ])
], -1))
const _hoisted_17 = { class: "text-start text-captilize" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_datepicker, {
              modelValue: $setup.fromdate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.fromdate) = $event)),
              class: "form-control"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_datepicker, {
              modelValue: $setup.todate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.todate) = $event)),
              class: "form-control"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary p-2 mt-3",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchcall && $setup.searchcall(...args)))
            }, "Search")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.summary, (record) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: record.id
                }, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(record.rider_name), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(record.rider_phone), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(record.total_order), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(record.earning_amount), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(parseFloat(Number(record.cash_amount))), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(parseFloat(record.earning_amount)-parseFloat(Number(record.cash_amount))), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}